import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { adminApiHeader, finalRouteApi } from '../../components/CommonApis/CommonApiUrl';
import AdminBackNavigation from '../../components/CommonComponents/AdminBackNavigation';

export default function FieldSetForm(){
  const navigate = useNavigate();
  const { id } = useParams();
  const editing = !!id;
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fields, setFields] = useState([]);
  const [form, setForm] = useState({ name:'', description:'', active:true, items:[] });

  useEffect(()=>{ let m=true; (async()=>{
    try{
      const feat = await axios.get(`${finalRouteApi}/admin/features/custom-fields`, { headers: adminApiHeader });
      if(!m) return;
      if(!feat.data?.enabled){ setEnabled(false); setLoading(false); return; }
      setEnabled(true);
      const list = await axios.get(`${finalRouteApi}/custom-fields`, { headers: adminApiHeader });
      if(!m) return; setFields(list.data?.fields||[]);
      if(editing){
        const res = await axios.get(`${finalRouteApi}/custom-field-sets/${id}`, { headers: adminApiHeader });
        if(!m) return; setForm({ name:res.data.set.name, description:res.data.set.description, active:res.data.set.active, items:(res.data.set.items||[]).map(it=>({ custom_field_id: it.custom_field_id, order: it.order })) });
      }
    }catch(e){ setError(e?.response?.data?.message||e.message); } finally{ setLoading(false); }
  })(); return ()=>{m=false}; },[id, editing]);

  const canSubmit = useMemo(()=> form.name.trim() && form.items.every(it=>it.custom_field_id), [form]);

  const addItem = ()=> setForm(f=> ({...f, items:[...f.items, { custom_field_id:'', order: (f.items.length||0)+1 }]}));
  const rmItem = (idx)=> setForm(f=> ({...f, items: f.items.filter((_,i)=>i!==idx)}));

  const submit = async ()=>{
    setError('');
    try{
      const payload = { ...form };
      if(editing) await axios.patch(`${finalRouteApi}/custom-field-sets/${id}`, payload, { headers: adminApiHeader });
      else await axios.post(`${finalRouteApi}/custom-field-sets`, payload, { headers: adminApiHeader });
      navigate('/custom-fields/sets');
    }catch(e){ setError(e?.response?.data?.message||e.message); }
  };

  if(loading) return <div>Loading…</div>;
  if(!enabled) return <div>Custom Fields addon is disabled.</div>;

  return (
    <div>
      <AdminBackNavigation path="/custom-fields/sets" text="Back to Field Sets" />
      <h2>{editing? 'Edit Field Set':'Create Field Set'}</h2>
      {error && <div style={{color:'red'}}>{error}</div>}
      <div className="mb-2">
        <label>Name</label>
        <input className="form-control" value={form.name} onChange={e=> setForm(f=> ({...f, name:e.target.value}))} />
        {!form.name?.trim() && <small style={{color:'red'}}>Name is required</small>}
      </div>
      <div className="mb-2">
        <label>Description</label>
        <textarea className="form-control" value={form.description||''} onChange={e=> setForm(f=> ({...f, description:e.target.value}))} />
      </div>
      <div className="mb-2">
        <label><input type="checkbox" checked={form.active} onChange={e=> setForm(f=> ({...f, active:e.target.checked}))} /> Active</label>
      </div>
      <div className="mb-2">
        <label>Items</label>
        {(form.items||[]).map((it,idx)=> (
          <div key={idx} style={{display:'flex',gap:8,marginBottom:6}}>
            <select className="form-control" value={it.custom_field_id} onChange={e=>{
              const arr=[...form.items]; arr[idx] = { ...arr[idx], custom_field_id: e.target.value }; setForm(f=> ({...f, items:arr}));
            }}>
              <option value=''>-- select field --</option>
              {(fields||[]).map(f=> <option key={f.id} value={f.id}>{f.name} ({f.key})</option>)}
            </select>
            <input type="number" className="form-control" value={it.order||0} onChange={e=>{
              const arr=[...form.items]; arr[idx] = { ...arr[idx], order: parseInt(e.target.value||0) }; setForm(f=> ({...f, items:arr}));
            }} />
            <button className="btn btn-danger" onClick={()=> rmItem(idx)}>X</button>
          </div>
        ))}
        <button className="btn btn-secondary" onClick={addItem}>+ Add Item</button>
      </div>
      <div>
        <button className="btn btn-primary" disabled={!canSubmit} onClick={submit}>{editing? 'Update':'Create'}</button>
      </div>
    </div>
  );
}
